var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06104 46.858L26.333 30.87L62.877 33.154L65.161 69.6979L49.173 87.9699C49.173 87.9699 49.1753 74.2682 35.469 60.562C21.7627 46.8557 8.06104 46.858 8.06104 46.858Z",
    fill: "#0F2C52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.00004 87.97C8.00004 87.97 7.91782 69.746 14.8178 62.846C21.7177 55.9461 40.0377 56.4211 40.0377 56.4211C40.0377 56.4211 40.0354 74.266 33.1834 81.118C26.3314 87.97 8.00004 87.97 8.00004 87.97Z",
    fill: "#FDBA2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3313 78.834C31.377 78.834 35.4673 74.7437 35.4673 69.698C35.4673 64.6523 31.377 60.562 26.3313 60.562C21.2856 60.562 17.1953 64.6523 17.1953 69.698C17.1953 74.7437 21.2856 78.834 26.3313 78.834Z",
    fill: "#FDBA2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0002 8.03003C88.0002 8.03003 65.1602 8.03003 37.7523 30.87C24.0483 42.29 24.0483 62.846 28.6163 67.414C33.1843 71.9819 53.7403 71.9819 65.1602 58.278C88.0002 30.87 88.0002 8.03003 88.0002 8.03003Z",
    fill: "#668199"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.444 19.45C63.737 19.45 60.5623 21.6677 59.1279 24.8402C60.2745 24.3217 61.5375 24.0179 62.876 24.0179C67.9213 24.0179 72.012 28.1086 72.012 33.1539C72.012 34.4924 71.7082 35.7554 71.192 36.8997C74.3645 35.4676 76.58 32.2929 76.58 28.5859C76.58 23.5406 72.4893 19.45 67.444 19.45Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0493 71.9819C24.0493 71.9819 24.0493 62.8459 26.3333 60.5619C28.6173 58.2779 56.0276 35.4402 58.3093 37.7219C60.591 40.0036 37.751 67.4139 35.467 69.6979C33.183 71.9819 24.0493 71.9819 24.0493 71.9819Z",
    fill: "#0F2C52"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.2e6e71a428fa38f3e661aed3ace624e5.svg";
export { ForwardRef as ReactComponent };